module.exports = __webpack_public_path__ + "img/return.f58d2d94.png";